import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false,
};

export const digitalDiscussionReducer = createReducer(initialState, {
  [types.DISCUSSION_DROPDOWN](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.CLASS_PLAYER](state, action) {
    return {
      ...state,
      classPlayer: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
